export default function ItalicIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="14"
      data-name="Icon - Italic"
      viewBox="0 0 9 14"
    >
      <path
        fill="currentColor"
        d="M9-15.75a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v.485a.5.5 0 00.5.5h1.461l-2.5 10.957H.5a.5.5 0 00-.5.5v.558a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-.558a.5.5 0 00-.5-.5H4.039l2.5-10.957H8.5a.5.5 0 00.5-.5z"
        data-name="Path 10403"
        transform="translate(0 16.25)"
      ></path>
    </svg>
  );
}
